import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from '../../Components/FieldInput'
import FieldSelect from '../../Components/FieldSelect'
import API from '../../Common/API'
import { useDispatch, useSelector } from "react-redux"
import TextEditor from '../../Components/Editor';
import { Dropzone, FileMosaic } from "@files-ui/react";
import axios from "axios"
import { setAlert } from "../../Store/Theme/actions"
import { useHistory } from "react-router-dom"

const initialProductForm = {
    productName: '',
    tProductName: '',
    brandName: '',
    tBrandName: '',
    category: '',
    addedBy: '',
    subCategory: '',
    modelName: '',
    tModelName: '',
    productDescription: '',
    netQuantity: 0.00,
    netQuantityType: '',
    orderQuantity: 0,
    productImages: [],
    manufacturer: '',
    price: 0,
    cgst: 0,
    sgst: 0,
    offer: 0,
    productQuantity: 0,
    shipmentVia: '',
    stockMode: '',
    deliveryCharges: 0
}


const stockModes = [{ text: 'In Stock', value: 'inStock' }, { text: "Out Of Stock", value: 'outOfStock' }, { text: 'Unavailable', value: 'unavailable' }, { text: 'Coming Soon', value: 'comingSoon' }]

const EditProducts = ({ match }) => {

    const [fullCategory, setFullCategory] = useState([])
    const [category, setCategory] = useState([])
    const [subCategory, setSubCategory] = useState([])
    const [files, setFiles] = React.useState([]);
    const [formData, setFormData] = useState(initialProductForm)
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const [sellerDetails, setSellerDetails] = useState([])
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const history = useHistory()
    const [shippingPoints, setShippingPoints] = useState([])

    useEffect(() => {
        axios.all([API.get('/category/completeCategories'), API.get('/accounts/getSellerAccountList'), API.get(`/products/getProductDetails/${match.params.prodId}`), API.get('/shipping/shippingPoints')]).then(axios.spread((catRes, sellerRes, productRes, shippingRes) => {
            setFormData(productRes.data.data)
            setFullCategory(catRes.data.data)
            setCategory(catRes.data.data.map((x) => { return { text: x.category, value: x._id } }))
            setSellerDetails(sellerRes.data.data.map((seller) => { return { text: seller.accountName, value: seller._id } }))
            setShippingPoints([{ text: "By Own", value: 1 }, ...shippingRes.data.data.map((ship) => { return { text: ship.goDownName, value: ship._id } })])
            setFiles(productRes.data.data.productImages.map((c, i) => ({
                id: i + 1,
                _id:c._id,
                name: c.imageUrl.split('firebasestorage.app')[1].split('/')[1].split('?')[0],
                size: 500000,
                type: "image/jpeg",
                preview: c.imageUrl
            })))
            const selectCat = catRes.data.data?.filter((x) => x._id === productRes.data.data.category)[0]
            setSubCategory(selectCat?.subCategories?.map((y) => { return { text: y.subCategory, value: y._id } }))
        }))
        setLoading(false)
    }, [])

    const productFormShcema = Yup.object().shape({
        productName: Yup.string().required("Product Name is required"),
        tProductName: Yup.string().nullable(),
        brandName: Yup.string().required("Brand Name is required"),
        tBrandName: Yup.string().nullable(),
        category: Yup.string().required("Category is required"),
        subCategory: Yup.string().required("Sub Category is required"),
        productDescription: Yup.string().nullable(),
        modelName: Yup.string().nullable(),
        tModelName: Yup.string().nullable(),
        addedBy: Yup.string().required("Seller Id is required"),
        // netQuantity: Yup.number(),
        // netQuantityType: Yup.string(),
        orderQuantity: Yup.number(),
        productImages: Yup.array(),
        manufacturer: Yup.string(),
        price: Yup.number(),
        cgst: Yup.number(),
        sgst: Yup.number(),
        productQuantity: Yup.number(),
        stockMode: Yup.string(),
        deliveryCharges: Yup.number(),
        shipmentVia: Yup.string().required("ShipmentVia is required"),
    })

    const productForm = useFormik({
        initialValues: formData,
        validateOnMount: true,
        validationSchema: productFormShcema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setSubmitDisabled(true)
            values.productImages = files
            values.status = 'Approved'
            const formData = new FormData();
            formData.append('productData', JSON.stringify(values));
            files.forEach((file) => {
                formData.append('files', file.file);
            });
            API.post('/products/editProduct', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((prodRes) => {
                if (prodRes.status === 200) {
                    dispatch(setAlert({ title: "Product Updated", subtitle: "Product has been updated successfully", active: true, type: 'success' }))  // Dispatched an alert
                    setSubmitDisabled(false)
                    history.push('/products')
                }
            }).catch((err) => {
                setSubmitDisabled(false)
            })
        }
    })

    const selectSubCategory = (value) => {
        const selectCat = fullCategory?.filter((x) => x._id === value)[0]
        setSubCategory(selectCat?.subCategories?.map((y) => { return { text: y.subCategory, value: y._id } }))
    }

    const updateFiles = (incommingFiles) => {
        //do something with the files
        console.log("incomming files", incommingFiles);
        setFiles(incommingFiles);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        setFiles(files.filter((x) => x.id !== id));
    };
    const translateFormHandling = async (text, fieldName) => {
        API.post('/common/translate', { text: text }).then((res) => {
            if (res.status === 200) {
                const tText = res.data.data.translatedText;
                productForm.setFieldValue(fieldName, tText); // Corrected this line
            }
        }).catch((error) => {
            console.error("Translation API Error:", error);
        });
    };
    console.log(files)
    return (
        <>
            {
                loading ? "Loading please wait ..." :
                    <motion.div className="relative h-full w-full flex bg-white py-2 px-2 flex-col">
                        <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2">
                            <FieldSelect label="Seller Id" fieldProps={productForm.getFieldProps('addedBy')} fieldHelper={productForm.getFieldHelpers('addedBy')} fieldMeta={productForm.getFieldMeta('addedBy')} edit={true} dataLoaded={true} options={sellerDetails} />
                            <FieldInput required={true} label="Product Name" fieldProps={productForm.getFieldProps('productName')} fieldMeta={productForm.getFieldMeta('productName')} fieldHelper={productForm.getFieldHelpers('productName')} edit={true} dataLoaded={true} onChange={(e) => translateFormHandling(e, 'tProductName')} />
                            <FieldInput label="தயாரிப்பு பெயர்" fieldProps={productForm.getFieldProps('tProductName')} fieldMeta={productForm.getFieldMeta('tProductName')} fieldHelper={productForm.getFieldHelpers('tProductName')} edit={true} dataLoaded={true} onChange={(e) => translateFormHandling(e, 'tProductName')} />
                            <FieldInput required={true} label="Brand Name" fieldProps={productForm.getFieldProps('brandName')} fieldMeta={productForm.getFieldMeta('brandName')} fieldHelper={productForm.getFieldHelpers('brandName')} edit={true} dataLoaded={true} onChange={(e) => translateFormHandling(e, 'tBrandName')} />
                            <FieldInput label="பிராண்ட் பெயர்" fieldProps={productForm.getFieldProps('tBrandName')} fieldMeta={productForm.getFieldMeta('tBrandName')} fieldHelper={productForm.getFieldHelpers('tBrandName')} edit={true} dataLoaded={true} />
                            <FieldSelect required={true} label="Category" fieldProps={productForm.getFieldProps('category')} fieldMeta={productForm.getFieldMeta('category')} fieldHelper={productForm.getFieldHelpers('category')} edit={true} dataLoaded={true} options={category} onChange={(ev) => selectSubCategory(ev)} />
                            <FieldSelect required={true} label="Sub Category" fieldProps={productForm.getFieldProps('subCategory')} fieldMeta={productForm.getFieldMeta('subCategory')} fieldHelper={productForm.getFieldHelpers('subCategory')} edit={true} dataLoaded={true} options={subCategory} />
                            <FieldInput label="Model Name" fieldProps={productForm.getFieldProps('modelName')} fieldHelper={productForm.getFieldHelpers('modelName')} fieldMeta={productForm.getFieldMeta('modelName')} edit={true} dataLoaded={true} onChange={(e) => translateFormHandling(e, 'tModelName')} />
                            <FieldInput label="மாதிரி பெயர்" fieldProps={productForm.getFieldProps('tModelName')} fieldHelper={productForm.getFieldHelpers('tModelName')} fieldMeta={productForm.getFieldMeta('tModelName')} edit={true} dataLoaded={true} />
                            <FieldInput label="Order Quantity" fieldProps={productForm.getFieldProps('orderQuantity')} fieldHelper={productForm.getFieldHelpers('orderQuantity')} fieldMeta={productForm.getFieldMeta('orderQuantity')} edit={true} dataLoaded={true} />
                            <FieldInput label="Manufacturer" fieldProps={productForm.getFieldProps('manufacturer')} fieldHelper={productForm.getFieldHelpers('manufacturer')} fieldMeta={productForm.getFieldMeta('manufacturer')} edit={true} dataLoaded={true} />
                            <FieldInput label="Price" fieldProps={productForm.getFieldProps('price')} fieldHelper={productForm.getFieldHelpers('price')} fieldMeta={productForm.getFieldMeta('price')} edit={true} dataLoaded={true} />
                            <FieldInput label="CGST" fieldProps={productForm.getFieldProps('cgst')} fieldHelper={productForm.getFieldHelpers('cgst')} fieldMeta={productForm.getFieldMeta('cgst')} edit={true} dataLoaded={true} />
                            <FieldInput label="SGST" fieldProps={productForm.getFieldProps('sgst')} fieldHelper={productForm.getFieldHelpers('sgst')} fieldMeta={productForm.getFieldMeta('sgst')} edit={true} dataLoaded={true} />
                            <FieldInput label="Offer" fieldProps={productForm.getFieldProps('offer')} fieldHelper={productForm.getFieldHelpers('offer')} fieldMeta={productForm.getFieldMeta('offer')} edit={true} dataLoaded={true} />
                            <FieldInput label="Stock Quantity" fieldProps={productForm.getFieldProps('productQuantity')} fieldHelper={productForm.getFieldHelpers('productQuantity')} fieldMeta={productForm.getFieldMeta('productQuantity')} edit={true} dataLoaded={true} />
                            <FieldSelect label="Stock Mode" fieldProps={productForm.getFieldProps('stockMode')} fieldHelper={productForm.getFieldHelpers('stockMode')} fieldMeta={productForm.getFieldMeta('stockMode')} edit={true} dataLoaded={true} options={stockModes} />
                            <FieldSelect label="Shipment Via" fieldProps={productForm.getFieldProps('shipmentVia')} fieldHelper={productForm.getFieldHelpers('shipmentVia')} fieldMeta={productForm.getFieldMeta('shipmentVia')} edit={true} dataLoaded={true} options={shippingPoints} />
                            {/* <FieldInput label="Delivery Charges" fieldProps={productForm.getFieldProps('deliveryCharges')} fieldHelper={productForm.getFieldHelpers('deliveryCharges')} fieldMeta={productForm.getFieldMeta('deliveryCharges')} edit={true} dataLoaded={true} /> */}
                        </motion.div>
                        <motion.div className="grid gird-cols-1 gap-10 px-5">
                            <motion.div className="flex flex-col w-full">
                                <motion.div className="text-md">
                                    Product Description
                                </motion.div>
                                {productForm.values.productDescription && <TextEditor
                                    values={productForm.values.productDescription}  // Ensure a default value
                                    onChange={(values) => productForm.setFieldValue("productDescription", values)}
                                />}
                            </motion.div>
                            <motion.div className="flex flex-col w-full">
                                <motion.div className="text-md">
                                    Product Images
                                </motion.div>
                                <Dropzone className="relative my-2"
                                    onChange={updateFiles}
                                    value={files}
                                    accept="image/*"
                                >
                                    {files.map((file) => (
                                        <FileMosaic preview={true} key={file.id} {...file} onDelete={removeFile} info />
                                    ))}
                                </Dropzone>
                            </motion.div>
                        </motion.div>
                        <motion.div className="w-full flex flex-row justify-center">
                            <motion.div className="bg-white/20 ring-1 ring-black mx-2 cursor-pointer rounded-full px-5 py-2 h-8 flex flex-row justify-center items-center" onClick={() => history.goBack()}>Cancel</motion.div>
                            <motion.div className={`bg-primeColor/20 rounded-full mx-2 ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} px-5 py-2 h-8 flex flex-row justify-center items-center`} onClick={() => !submitDisabled && productForm.submitForm()}>Submit</motion.div>
                        </motion.div>
                    </motion.div>
            }
        </>
    )
}

export default EditProducts